import React from "react"
export default function ProvinceList() {
  return (
    <div>
      <h3>Province-Wide Coverage!</h3>
      <p>Our network of process servers is located in:</p>
      <ul style={{"listStyle": "disc"}}>
        <li>Saskatoon</li>
        <li>Regina</li>
        <li>Prince Albert</li>
        <li>Battleford</li>
        <li>Swift Current</li>
        <li>Kindersley</li>
        <li>Estevan</li>
        <li>Yorkton</li>
        <li>Moose Jaw</li>
        <li>Melfort</li>
      </ul>
      <p>We also serve communities beyond these locations, <a className="link transition" href="mailto:service@prairieprocessserving.com">email us</a> today for our full list.</p>
    </div>
  )
}